import { ApplicationState } from "#store/types";

export const selectId = (state: ApplicationState, id: number) => id;
export const selectIds = (state: ApplicationState, ids: number[]) => ids;
